export const OTP_VALID_SECONDS = 5 * 60;

export const USER_ROLE_OPTIONS = [
  { value: 'STUDENT', label: '수강생' },
  { value: 'FACILITATOR', label: 'FT' },
  { value: 'ADMIN', label: '관리자' },
  { value: 'OPERATOR', label: '교육운영자' },
];

/**
 * 권한 타입 한글 매핑
 */
export const USER_TYPE_LABEL_MAP = {
  STUDENT: '교육생',
  FACILITATOR: 'FT',
  ADMIN: '관리자',
  OPERATOR: '교육운영자',
};

/**
 * 권한별 뱃지 색상 매핑
 */
export const USER_TYPE_COLOR_MAP = {
  ADMIN: 'error',
  OPERATOR: 'primary',
  FACILITATOR: 'warning',
  STUDENT: 'success',
};